import React from 'react';
import PropTypes from 'prop-types';
import { Table, Dropdown, Icon } from 'semantic-ui-react';

export const LocationContactInfoAction = {
  EDIT: 'Edit Contact',
};

const SelectableItem = ({
  value, text, disabled, onSelectAction,
}) => {
  return (
    <Dropdown.Item
      text={text}
      value={value}
      onClick={disabled ? undefined : (e, data) => onSelectAction(e, data)}
      style={disabled ? { color: 'gray', pointerEvents: 'none', opacity: 0.5 } : {}}
    />
  );
};

SelectableItem.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onSelectAction: PropTypes.func.isRequired,
};

SelectableItem.defaultProps = {
  disabled: false,
};

const LocationContactListRow = (actionHandler, isAuctionLocationEditor) => (allContact, index) => {
  const onSelectAction = (e, data) => {
    e.preventDefault();
    const action = data.value;
    actionHandler(allContact, action);
  };

  const statusIcon = truthly => {
    if (truthly) {
      return <Icon color='green' name='checkmark' size='large' />;
    }
    return <Icon color='red' name='close' size='large' />;
  };

  const {
    auctionName,
    contactName,
    title,
    isBlockedEmail,
    contactEmail,
    phone,
    contactType,
    guaranteeConfirm,
    guaranteeCancel,
    returns,
    vehNotCovered,
  } = allContact;

  return (
    <Table.Row key={index}>
      <Table.Cell>
        <div className='space-pre-wrap word-break-word'>
          {auctionName || ''}
        </div>
      </Table.Cell>
      <Table.Cell className='space-pre-wrap word-break-word'>
        {contactName || ''}
      </Table.Cell>
      <Table.Cell className='space-pre-wrap word-break-word'>
        {title || ''}
      </Table.Cell>
      <Table.Cell
        className={
          isBlockedEmail
            ? 'error-text word-break-word'
            : 'word-break-word'
        }
      >
        {contactEmail || ''}
      </Table.Cell>
      <Table.Cell className='word-break-word'>
        {phone || ''}
      </Table.Cell>
      <Table.Cell className='word-break-word'>
        {contactType.split(',').join(', ') || ''}
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>
          {statusIcon(guaranteeConfirm)}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>
          {statusIcon(guaranteeCancel)}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>{statusIcon(returns)}</div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>
          {statusIcon(vehNotCovered)}
        </div>
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          pointing='top right'
          icon='ellipsis horizontal'
          className='no-pointer-dropdown'
        >
          <Dropdown.Menu>
            <SelectableItem
              text={LocationContactInfoAction.EDIT}
              value={LocationContactInfoAction.EDIT}
              disabled={!isAuctionLocationEditor}
              onSelectAction={onSelectAction}
            />
          </Dropdown.Menu>
        </Dropdown>
      </Table.Cell>
    </Table.Row>
  );
};

export default LocationContactListRow;
